// APP
export const SET_ALERT = "SET_ALERT";
export const SET_ALERT_VISIBILITY = "SET_ALERT_VISIBILITY";
